import styled from "@emotion/styled";
import * as v from "variables/styles";

export const SearchRoleContainer = styled.div({
  "&>div>div.ui.menu": {
    overflowX: "scroll",
  },

  "@media only screen and (min-width: 600px)": {
    "&>div>div.ui.menu": {
      overflowX: "unset",
    },
  },

  "@media only screen and (min-width: 769px)": {
    "&>div>div.ui.menu": {
      overflowX: "unset",
    },
  },

  ".rowFields": {
    display: "flex",
    flex: 1,
    flexDirection: "row",
    paddingTop: '15px'
  },

  ".warnningMSG": {
    marginTop: "1.5rem",
    color: "red",
    marginBottom: "1.5rem",
    fontSize: "1rem",
    b: {
      fontSize: "1rem",
    },
    ul: {
      listStyleType: "none",
      paddingLeft: "1rem",
      marginTop: "0",
    },
  },
});

export const DataListCont = styled.div((props) => ({
  marginTop:'1rem',
  // width:'80vw',

  '.ui.table':{
    borderWidth:0
  },

  '.ReactTable .rt-thead.-header':{
    boxShadow:'none',
    background: '#eaeff5'
  },

  '.ReactTable':{
    borderRadius:'0.5rem'
  },

  '.ReactTable .rt-thead .rt-th':{
    borderRight: 0
  },

  '.ReactTable .rt-tbody .rt-td':{
    borderRight: 0
  },

  '.-padRow':{
    cursor:'default !important'
  },

  '.ReactTable .rt-tr':{
    cursor:'pointer'
  },

  '@media only screen and (min-width: 600px)': {
    // width: '100vw',
  },

  '@media only screen and (min-width: 769px)': {
    width: '80vw',
  },

}))
